import React from 'react';
import { Grid, Modal } from 'antd';

const { useBreakpoint } = Grid;

export function FormSheet({
  title,
  open,
  onClose,
  children,
  width = 880,
}: {
  title: React.ReactNode;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: number;
}) {
  const screens = useBreakpoint();
  const mobile = screens.md === false;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={mobile ? '100%' : width}
      centered={!mobile}
      destroyOnClose
      className={mobile ? 'sn-form-sheet is-mobile' : 'sn-form-sheet'}
      styles={{
        body: {
          paddingTop: 4,
          maxHeight: mobile ? 'calc(100vh - 108px)' : 'min(76vh, 780px)',
          overflow: 'auto',
        },
      }}
    >
      {children}
    </Modal>
  );
}
